<template>
  <div class="wrapper" id="printPage" v-loading="!info.supplierType">
    <div class="box-all">
      <div class="box-1">
        <div class="box-2">
          <div class="box-3">
            <div class="box-4">
              <ul class="list-1">
                <li><img src="@/assets/img/report/logo.png" alt=""></li>
                <h3>产品质量评价证书</h3>
                <li style="margin-top: 10px"><h5>证书编号: {{info.reportNo}}</h5></li>
              </ul>
              <ul class="list-2">
                <li><strong>企业名称</strong><span>{{info.companyName}}</span></li>
                <li><strong>企业地址</strong><span>{{info.address}}</span></li>
                <li v-if="info.factory"><strong>生产地址</strong><span>{{info.factory}}</span></li>
                <li><strong>产品类别</strong><span>{{info.className}}</span></li>
              </ul>
              <div class="con-tab">
                <h4>经现场审查和产品实物测试，依据《<span>{{info.evaluateMethodName}}</span>质量评价办法》，贵公司产品质量评价结果和限制范围如下：</h4>
                <table id="tab1">
                  <tbody>
                  <tr>
                    <th width="40">序号</th>
                    <th>产品名称</th>
                    <th width="62">质量等级</th>
                    <th>限制范围</th>
                  </tr>
                  <tr>
                    <td>1</td>
                    <td class="ellipsis"><p class="w150">{{info.productName}}</p></td>
                    <td>{{info.grade}}</td>
                    <td class="ellipsis"><p class="w150">{{info.scopeOfApplication}}</p></td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="c-foot-box">
                <span class="c-left-span">有效期至：{{info.showCreditDeadlineStr}}</span>
                <span class="c-right-span">
                  <span class="f-1">易派客电子商务有限公司</span>
                  <span style="margin-top: 25px;">{{info.creditStartDateStr}}</span>
                  </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="print-btn no-print" v-if="isShowExport">
      <eui-btn type="primary" @click="handleExportPdf">导出PDF</eui-btn>
    </div>
  </div>
</template>

<script>
import Api from '@/modules/projectA/api/ESorganization';

export default {
  name: 'viewReport',
  data() {
    return {
      info: {},
      isShowExport: true
    };
  },
  created() {
    Api.queryEvaluationReport({
      evaluationItemId: this.$route.query.evaluationItemId,
      id: this.$route.query.id
    }).then(res => {
      if (res.code === '200') {
        this.info = res.data;
      }
    });
  },
  methods: {
    handleExportPdf() {
      this.isShowExport = false;
      this.$nextTick(() => {
        this.getPdf('printPage', `产品质量评价证书(NO:${this.info.reportNo || ''})`, () => {
          this.isShowExport = true;
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
  @media print {
    /* 打印时不需要显示的元素 */
    .no-print {
      display: none !important;
    }
    #printPage {
      transform-origin: left top !important;
      -webkit-print-color-adjust: exact;
      -moz-print-color-adjust: exact;
      -ms-print-color-adjust: exact;
      print-color-adjust: exact;
    }
    .calendar {
      /* 隐藏日历页面中不需要打印的元素 */
      display: none;
    }
  }

  .print-btn {
    text-align: center;
    padding-bottom: 20px;
  }

  .wrapper {
    background: #fff;
    color: #666;
    font-family: "simsun";
    width: 780px;
    margin: 0 auto;
    padding-bottom: 0;
  }

  table {
    background: #fff;
    color: #666;
    border-collapse: collapse;
    border-spacing: 0;
    text-align: center;
  }

  li {
    list-style: none;
  }

  .box-all {
    padding: 25px 20px;
    width: 780px;
    margin: 30px auto;
    border: 1px solid #ccc;
  }

  .box-1 {
    background: url(~@/assets/img/report/backdrop-1.png);
    width: 720px;
    margin: 0 auto;
    padding: 11px 0;
  }

  .box-2 {
    width: 720px;
    background: url(~@/assets/img/report/backdrop-2.png) #ffffff;
    padding: 0 10px;
  }

  .box-4 {
    background: url(~@/assets/img/report/back.jpg) #ffffff;
    padding: 30px;
  }

  .list-1 {
    text-align: center;
  }

  .list-1 h3 {
    font-size: 20px;
    font-weight: 600;
    color: #333;
  }

  .list-1 h5 {
    font-size: 14px;
    font-weight: 600;
  }

  .list-1 li {
    margin-bottom: 15px;
  }

  .list-2 {
    font-size: 12px;
    margin-top: 40px;
  }

  .list-2 strong, .list-2 span {
    float: left;
    display: block;
    line-height: 30px;
  }

  .list-2 strong {
    font-weight: 600;
  }

  .list-2 span {
    border-bottom: 1px solid #ccc;
    width: 570px;
    height: 22px;
    line-height: 29px;
    margin-left: 15px;
  }

  .list-2 li {
    overflow: hidden;
    margin: 15px auto;
  }

  .list-2 li p {
    text-align: center;
    font-weight: 600;
  }

  .con-tab {
    margin: 40px 0 100px;
    font-size: 12px;
    width: 100%;
  }

  .con-tab h4 {
    font-weight: 600;
    line-height: 25px;
    text-indent: 2em;
    padding-bottom: 8px;
  }

  .con-tab table {
    width: 100%;
    line-height: 30px;
    text-align: center;
  }

  .con-tab table tr td, .con-tab table tr th {
    border: 1px solid #ccc;
  }

  .con-tab table tr th {
    background: #F5F5F5;
    font-weight: 600;
    white-space: nowrap;
  }

  .con-tab table p {
    width: 60px;
    margin: 0 auto;
    padding: 5px;
    line-height: 24px;
  }

  .con-tab table p.w150 {
    min-width: 150px;
    width: auto;
    white-space: pre-line;
  }

  .c-foot-box {
    height: 220px;
  }

  .c-foot-box span {
    display: block;
    font-size: 12px;
  }

  .c-foot-box span.c-left-span {
    width: 300px;
    float: left;
    padding-top: 70px;
  }

  .c-foot-box span.c-right-span {
    width: 240px;
    float: right;
    padding-top: 64px;
    padding-right: 17px;
    background: url('~@/assets/img/report/epec-company.png') no-repeat 45px;
    height: 150px;
    display: inline-block;
    vertical-align: text-bottom;
  }

  .c-right-span span {
    display: block;
    margin-bottom: 10px;
    text-align: right;
  }

  .c-right-span span.f-1 {
    font-size: 14px;
    font-weight: 600;
  }

  .ellipsis {
    width: 150px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

</style>

<style>
  @media print {
    html, body, #app, .wrapper {
      height: auto !important;
    }
  }
</style>
